export default __webpack_public_path__ + "static/media/Ecoe_logo_h_white.91daf725.svg";